<template>
<div>
	<div class="container main-content">
		<div class="vertical-center getting-quote">
			<div class="container main-content">
				<div class="row text-center">
					<div class="col-12">
						<template v-if="isProcessing">
							Verifying... <i class="fas fa-circle-notch fa-spin"></i>
						</template>
						<template v-else>
							{{ errorMsg }}
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
	
</div>
</template>

<script>

import { eventBus } from './../main'

export default {
	data() {
		return {
			isProcessing: true,
			refId: null,
			queryString: null,
			errorMsg: null,
		}
	},
	created(){
		
	}, 
	mounted() {
		
		this.refId = this.$route.params.refId;
		this.queryString = this.$route.query;
		
		this.$gstate.log(this.refId);
		this.$gstate.log(this.queryString);

		if(this.refId == null){
			this.$gstate.redirectHome('', 100, 'Reference ID not found.');
			return 
		}

		this.getFlowState();
	},
	methods: {
		getFlowState(){
			var urlstr = this.$gstate.getApiBaseURL() + '/flowstate/' + this.refId;
			this.axios.get(urlstr)
				.then(response => {
					this.isProcessing = false;
					this.$gstate.saveFlowStateAndProceed(response.data, this);
					
				})
				.catch(error => {
					this.$gstate.log('getFlowState() error:');
					this.$gstate.log(error);
					this.errorMsg = error.response.data.error;
				});
		}
	},
}

</script>

